import { render, staticRenderFns } from "./SignFor.vue?vue&type=template&id=620f20d6&scoped=true&"
import script from "./SignFor_.js?vue&type=script&lang=js&"
export * from "./SignFor_.js?vue&type=script&lang=js&"
import style0 from "./SignFor.vue?vue&type=style&index=0&id=620f20d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f20d6",
  null
  
)

export default component.exports